import React from 'react'
import styled from 'styled-components'
import { useGlobalLabels } from '@sentecacommerce-theme/lib'
import { Typography } from '../Typography'
import { RemoveFromBasketButton } from '../RemoveFromBasketButton'
import { Placeholder } from '../Placeholder'

export const BasketPreviewItemPlaceholder = () => {
  const labels = useGlobalLabels()
  return (
    <Container>
      <ImageContainer>
        <Placeholder image width="50rem" />
      </ImageContainer>
      <Content>
        <Placeholder width="60%" />
        <Placeholder width="65%" className="mt-2" />
        <Placeholder width="57%" className="mt-2 mb-1" />
        <SKU>
          <span>{`${labels?.productNumber}:`}</span>
          <Placeholder width="3rem" className="ml-2 mt-1" />
        </SKU>
        <Bottom className="pt-4">
          <Placeholder width="6rem" />
          <ButtonCon className="mt-3">
            <Placeholder absolute />
          </ButtonCon>
        </Bottom>
        <RemoveContainer>
          <RemoveFromBasketButton lineItemId="" variantId="" productId="" />
        </RemoveContainer>
      </Content>
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'row gx-5',
})`
  position: relative;
  pointer-events: none;
`

const RemoveContainer = styled.div`
  position: absolute;
  top: -1rem;
  right: 0.5rem;
  pointer-events: none;
`

const ImageContainer = styled.span.attrs({
  className: 'col-5 col-md-4 d-block',
})`
  border-right: 0.1rem solid ${({ theme }) => theme.palette.disabled};
`

const Content = styled.div.attrs({
  className: 'col-7 col-md-8',
})`
  display: flex;
  flex-direction: column;
`

const SKU = styled(Typography).attrs({
  as: 'span',
  variant: '8',
  color: 'hint',
  className: 'd-flex mt-2 mb-4 pb-lg-2',
})`
  align-items: center;
`

const Title = styled(Typography).attrs({
  as: 'h3',
  variant: '5',
})`
  line-height: 1.2;
  padding-right: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

const Bottom = styled.div`
  border-top: 0.1rem solid ${({ theme }) => theme.palette.disabled};
`

const ButtonCon = styled.div`
  position: relative;
  width: 13rem;
  height: 4.4rem;
  border-radius: 3rem;
  overflow: hidden;
`
